module.exports = __webpack_public_path__ + "img/4.e249b05c.jpg";